module.exports = __webpack_public_path__ + "img/img_charge_img2.14eff129.png";